import { loadBrowserCache, saveBrowserCache } from "./browserCache";
import { loadIndexedCache, saveIndexedCache } from "./indexedDbCache";

const DRAFT_STORAGE_PREFIX = "lumen-tms-draft:";
const DEFAULT_DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

const canUseStorage = () => typeof window !== "undefined" && Boolean(window.localStorage);

export const loadOfflineSnapshot = async (storageKey, maxAgeMs) => {
  const browserValue = loadBrowserCache(storageKey, maxAgeMs);
  if (browserValue) {
    return browserValue;
  }
  return loadIndexedCache(storageKey, maxAgeMs);
};

export const saveOfflineSnapshot = async (storageKey, data) => {
  saveBrowserCache(storageKey, data);
  await saveIndexedCache(storageKey, data);
};

export const loadDraftState = (storageKey, maxAgeMs = DEFAULT_DRAFT_MAX_AGE_MS) => {
  if (!canUseStorage()) {
    return null;
  }
  try {
    const rawValue = window.localStorage.getItem(`${DRAFT_STORAGE_PREFIX}${storageKey}`);
    if (!rawValue) {
      return null;
    }
    const parsed = JSON.parse(rawValue);
    if (!parsed?.savedAt || typeof parsed.savedAt !== "number") {
      return null;
    }
    if (Date.now() - parsed.savedAt > maxAgeMs) {
      return null;
    }
    return parsed.data ?? null;
  } catch {
    return null;
  }
};

export const saveDraftState = (storageKey, data) => {
  if (!canUseStorage()) {
    return;
  }
  try {
    window.localStorage.setItem(`${DRAFT_STORAGE_PREFIX}${storageKey}`, JSON.stringify({ savedAt: Date.now(), data }));
  } catch {
    // no-op
  }
};

export const clearDraftState = (storageKey) => {
  if (!canUseStorage()) {
    return;
  }
  try {
    window.localStorage.removeItem(`${DRAFT_STORAGE_PREFIX}${storageKey}`);
  } catch {
    // no-op
  }
};